class HelpView {
	constructor(container) {
		this._container = ge(container);

		if (this._container === null) return;

		this._back = '<div class="help-back" onclick="help.back()"><span class="tx-span"><i class="i-rg i-chev-left"></i>'+_('BACK')+'</span></div>';
		onEv(document, 'helpLoadComplete', this.view.bind(this, null));
		this.reset();

		let home = baseName || 'home';
		this.fromName(home);
		this.isOpen = document.body.className.match(/hide-help/g) == null;
	}

	get currentTopic() {
		if (this._topics.length) return this._topics[this._level];
		return null;
	}
	
	reset() {
		this._level = -1;
		this._topics = [];
		this._container.innerHTML = '';
	}

	toggle() {
		if (document.body.className.match(/hide-help/g)){
			this.show();
		}
		else {
			this.hide();
		}
	}

	show() {
		document.body.className = document.body.className.replace(/hide-help/g, 'show-help');
		document.cookie = "show-help=1;path=/";
		this.isOpen = true;
	}

	hide() {
		document.body.className = document.body.className.replace(/show-help/g, 'hide-help');
		document.cookie = "show-help=0;path=/";
		this.isOpen = false;
	}
	
	fromName(name) {
		this.load(HelpTopic.fromName(name));
	}

	load(topic) {
		this.addCol();
		this._topics.push(topic);
		this.view();
	}

	view(value) {
		value = value || this.currentTopic.value;
		if (value != null) {
			value = HelpTopic.parse(value);
			this._container.lastChild.innerHTML = 0 < this._level ? this._back + value : value;
		}
		this.update();
	}

	addCol() {
		this._level++;
		this._container.appendChild(div('help-topic'));
		this.update();
	}

	back() {
		if (this._level == 0) return;
		this._level--;
		this._container.removeChild(this._container.lastChild);
		this._topics.pop();
		this.update();
		document.dispatchEvent(new Event('helpLoadComplete'));
	}

	update() {
		this._container.style.left = (360 * this._level * -1) + 'px';
	}
}